<template>
	<div class="parent" style="height:calc(100vh - 50px);">
		<layout-3 :id=pageid1 :term=term :width=3 :height=1 style="max-height:30vh;"></layout-3>
		<hr style="margin-left:25px;margin-right:25px;"/>
		<div style="overflow-y:auto; margin-bottom:80px;">
			<layout-1 v-if="perms.includes('56')" :table_name="'Job Orders'" :id=pageid2 :searchbar=false :collapseable="true" :height_limit="false" :navbar=false :select_reroute=true :button_perm="'2'" :button_name="'Select'" :term=term></layout-1>
			<layout-1 v-if="perms.includes('56')" :table_name="'Sister Vessels'" :id=pageid3 :searchbar=false :collapseable="true" :height_limit="false" :navbar=false :select_reroute=true :button_perm="'56'" :button_name="'Select'" :term=term :hide_first_column="true"></layout-1>
			<layout-1 v-if="perms.includes('56')" :table_name="'Same IMO Number'" :id=pageid4 :searchbar=false :collapseable="true" :height_limit="false" :navbar=false :select_reroute=true :button_perm="'56'" :button_name="'Select'" :term=term :hide_first_column="true"></layout-1>
			<layout-1 v-if="perms.includes('61')" :table_name="'Tech Documents'" :id=pageid5 :searchbar=false :collapseable="true" :height_limit="false" :navbar=false :select_reroute=true :button_perm="'61'" :button_name="'Select'" :term=term :hide_first_column="true"></layout-1>

			<div v-if="default_vesselpic!=''">
				<vesselpic
					:dir="'vesselpics/vesselpic_'+parseInt(default_vesselpic)+'.jpg'"
					:vesselpic_id="default_vesselpic"
					style="width:50%; height:calc(50%); margin:auto;">
				</vesselpic>
			</div>

		</div>
		<div class="nav-bar">
			<div>
				<button v-if="perms.includes('61')" v-on:click="button('Add')">Add Tech Document</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			perms:[],
			pageid1:PAGES.VIEW_VESSEL_HISTORY_PAGE,
			pageid2:PAGES.VESSEL_JOB_ORDERS_PAGE,
			pageid3:PAGES.VESSEL_SISTER_PAGE,
			pageid4:PAGES.VESSEL_IMO_PAGE,
			pageid5:PAGES.TECHDOCS_PAGE,
			pageid6:PAGES.VESSELHISTORY_VESSELPIC_PAGE,

			default_vesselpic:''
		}
	},
	async created () {
		this.perms = api.getPerms();
		this.setPicture();
	},
	methods:{
		async setPicture(){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid6,
						data:[this.term],
					}
				}
			).then((res) => {
				if(res.data.data.column_data[0][0]!=null){
					this.default_vesselpic = res.data.data.column_data[0][0];
				}
			});
		},
		async button (name){
			api.postData(
				{
					type:"button",
					data:{
						pageid:this.pageid5,
						buttonname:name,
					}
				}
			).then((res) => {
				if(res.data.data.to!=null) {
					if(res.data.data.useterm) {
						router.push('/'+res.data.data.to+'?q='+this.term);
					} else {
						router.push('/'+res.data.data.to);
					}
				}
			});
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/View_Vessel_History.vue